import React from 'react';
    import { HashRouter as Router, Routes, Route } from 'react-router-dom';

    import HomePage from './pages/HomePage';
    import ClarityClubPage from './pages/ClarityClubPage';
    import LinkInBioProPage from './pages/LinkInBioProPage';
    import LumadiousPage from './pages/LumadiousPage';
    import LaunchKitsPage from './pages/LaunchKitsPage';
    import AffiliatePathwaysPage from './pages/AffiliatePathwaysPage';
    import PromptToolsPage from './pages/PromptToolsPage';
    import ToolsPage from './pages/ToolsPage';
    import PremiumLandingPage from './pages/PremiumLandingPage';

    // Free Tools
    import BlogPostGeneratorPage from './pages/tools/BlogPostGeneratorPage';
    import SocialMediaCreatorPage from './pages/tools/SocialMediaCreatorPage';
    import LandingPageBuilderPage from './pages/tools/LandingPageBuilderPage';
    import HashtagGeneratorPage from './pages/tools/HashtagGeneratorPage';
    import FormBuilderPage from './pages/tools/FormBuilderPage';
    import EmailSequenceBuilderPage from './pages/tools/EmailSequenceBuilderPage';

    import './App.css';

    function App() {
      return (
        <Router>
          <div className="app">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/clarity-club" element={<ClarityClubPage />} />
              <Route path="/link-in-bio-pro" element={<LinkInBioProPage />} />
              <Route path="/lumadious" element={<LumadiousPage />} />
              <Route path="/launch-kits" element={<LaunchKitsPage />} />
              <Route path="/affiliate-pathways" element={<AffiliatePathwaysPage />} />
              <Route path="/prompt-tools" element={<PromptToolsPage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/premium-tools" element={<PremiumLandingPage />} />

              {/* Free Tool Routes */}
              <Route path="/tools/blog-post-generator" element={<BlogPostGeneratorPage />} />
              <Route path="/tools/social-media-creator" element={<SocialMediaCreatorPage />} />
              <Route path="/tools/landing-page-builder" element={<LandingPageBuilderPage />} />
              <Route path="/tools/hashtag-generator" element={<HashtagGeneratorPage />} />
              <Route path="/tools/form-builder" element={<FormBuilderPage />} />
              <Route path="/tools/email-sequence-builder" element={<EmailSequenceBuilderPage />} />
            </Routes>
          </div>
        </Router>
      );
    }

    export default App;